import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { RateOfferState } from "../../types/rate-offer";
import { selectRateOfferState } from "./rate-offer.slice";

export const useGetRateOfferState = () => {
  return useSelector<AppStore, RateOfferState>(selectRateOfferState);
};
